import { echartGaugeMonth } from '../common';

export function echartAnellGaugeMonth(vis, datos) {
  echartGaugeMonth(
    'chartAnellMesActual',
    'chartAnellMesAnterior',
    'no_dataAnellMesActual',
    'no_dataAnellMesAnterior',
    datos.resultset,
    'ANELL CICLISTA: EVOLUCIÓ ',
    'ANELL CICLISTA: EVOLUCIÓ ',
  );
}
export function echartAccesosGaugeMonth(vis, datos) {
  document
    .querySelector('#tabAccessosAnellCiclista')
    .addEventListener('click', () => {
      requestAnimationFrame(() => {
        echartGaugeMonth(
          'chartAccessosAnellMesActual',
          'chartAccessosAnellMesAnterior',
          'no_dataAccessosAnellMesActual',
          'no_dataAccessosAnellMesAnterior',
          datos.resultset,
          'ACCESSOS ANELL CICLISTA: EVOLUCIÓ ',
          'ACCESSOS ANELL CICLISTA: EVOLUCIÓ ',
        );
      });
    });
}
